import qs from "qs";

export const addQuerys = (url, params) => {
  const queryString = qs.stringify(params);
  return url + (url.includes("?") ? "&" : "?") + queryString;
};
export class AppError extends Error {
  name = "AppError";
}
// 倒计时
export function countdown(timeString, cb) {
  const [hours, minutes, seconds] = timeString.split(':').map(Number);
  let totalSeconds = hours * 3600 + minutes * 60 + seconds;

  const timerInterval = setInterval(() => {
    if (totalSeconds <= 0) {
      clearInterval(timerInterval);
      return;
    }

    totalSeconds--;

    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    let time = `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    console.log(time);

    cb && cb(time)

  }, 1000);

  return timerInterval
}